import { t, type StaffKey, type StaffLanguage } from './staffText'
import type { SetupStatusLine } from './types'

/** The Network section's rules, apart from the screen so they are tested without a DOM. */

export interface BranchGroup {
  id: string
  tenantId: string
  name: string
  branchIds: string[]
  updatedAt: string
}

/** The same number as org.MaxGroupName and migration 0054's CHECK. */
export const MAX_GROUP_NAME = 60

export function shownRows(rows: readonly SetupStatusLine[], group: BranchGroup | null | undefined): SetupStatusLine[] {
  if (!group) return [...rows]
  return rows.filter((r) => group.branchIds.includes(r.branchId))
}

export type Tone = 'ok' | 'bad'

/** The version a branch's floor runs, or why it runs none. */
export function statusState(row: SetupStatusLine, lang: StaffLanguage): { label: string; tone: Tone } {
  if (!row.active) return { label: t('network.outOfService', lang), tone: 'bad' }
  if (row.version < 1) return { label: t('admin.config.neverPublished', lang), tone: 'bad' }
  return { label: t('admin.config.live', lang, { version: row.version }), tone: 'ok' }
}

export function groupNameProblem(name: string, groups: readonly BranchGroup[], editingId?: string): StaffKey | null {
  const trimmed = name.trim()
  if (!trimmed) return 'network.groups.nameNeeded'
  if ([...trimmed].length > MAX_GROUP_NAME) return 'network.groups.nameTooLong'
  const folded = trimmed.toLowerCase()
  if (groups.some((g) => g.id !== editingId && g.name.trim().toLowerCase() === folded)) return 'network.groups.nameTaken'
  return null
}
